import React from "react";
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"

const CertMemberSectionItem = ({ blok }) => {
  return(
    <div {...storyblokEditable(blok)} className="p-5">
      <h3 className="text-2xl font-bold my-5">{blok.title}</h3>
      <div className="my-4" dangerouslySetInnerHTML={{__html: renderRichText(blok.description)}} />
      <div className="">
        <img className="w-auto h-[70px] object-fit" loading="lazy" src={`${blok.logo?.filename}/m/0x140`} alt={blok.logo?.alt}/>
      </div>
    </div>
  )
}

const CertMemberSection = ({ blok }) => {
  // console.log(blok)
  return(
    <section {...storyblokEditable(blok)} className="pt-10 pb-20 px-5 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {blok.certMemberItem?.map((item) => (<CertMemberSectionItem blok={item} key={item._uid}/>))}
      </div>
    </section>
  ) 
}

export default CertMemberSection
